import colors from "./colors";
import space from "./space";
import typography from "./typography";
import { breakpointStrings, mediaQueries, breakpoints } from "./breakpoints.js";
var sizes = [// maxWidth/maxHeight
'0px', '330px', '480px']; // active, disabled, hovered states needed

var shadows = {
  active: '0px 0px 4px rgba(9, 10, 12, 0.16)',
  hovered: '0px 4px 8px rgba(9, 10, 12, 0.16)',
  // Interal usage, not exposed
  normal: '0 1px 4px 0 rgba(0, 0, 0, 0.24)',
  inverted: '0 -1px 4px 0 rgba(0, 0, 0, 0.24)',
  raised: '2px 0 10px 0 rgba(0, 0, 0, 0.24)',
  focus: "0 0 0 2px ".concat(colors.blue['300'])
};
var borderWidths = {
  none: '0px',
  thin: '1px'
};
var zIndices = {
  minimum: 1,
  overlay: 500,
  toast: 7000,
  dialog: 5000,
  menu: 10000,
  select: 10001,
  highest: 10000001
};
var defaultTheme = {
  name: 'Default',

  /* Colors */
  colors: colors,
  space: space,
  fonts: typography.fonts,
  fontSizes: typography.fontSizes,
  fontWeights: typography.fontWeights,
  lineHeights: typography.lineHeights,
  letterSpacings: typography.letterSpacings,
  shadows: shadows,
  breakpoints: breakpointStrings,
  sizes: sizes,
  mediaQueries: mediaQueries,
  zIndices: zIndices,
  borderWidths: borderWidths
};
export default defaultTheme;
export { defaultTheme, mediaQueries, breakpoints };